// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6e1705aa","977":"91091774"}[chunkId] + ".chunk.js";
};